import { put, SagaGenerator, takeEvery } from "typed-redux-saga";
import { Action } from "typescript-fsa";

import { ActivityActions } from "@com.mgmtp.a12.client/client-core/lib/core/activity";

import { OpenInvitationModalPayload, openInvitationModal } from "../../processOverview/store/actions";

import { InvitationModalDescriptor } from "../descriptors";

export function* openInvitationModalSaga(): SagaGenerator<void> {
	yield* takeEvery(openInvitationModal.match, handle);
}

function* handle(action: Action<OpenInvitationModalPayload>): SagaGenerator<void> {
	yield* put(
		ActivityActions.create({
			initiatingActivityId: action.payload.initiatingActivityId,
			activityDescriptor: InvitationModalDescriptor.build({
				applicationKey: action.payload.applicationKey,
				sourceAppKeys: action.payload.sourceAppKeys,
				initiatingActivityId: action.payload.initiatingActivityId
			}),
			loadingState: "missing"
		})
	);
}
